import { createFileRoute, Link } from '@tanstack/react-router'
import useRequest from '@/lib/request/useRequest'
import { Button, Spinner } from '@heroui/react'
import { useNavigate } from '@tanstack/react-router'
import { useEffect, useRef, useState } from 'react'

export const Route = createFileRoute('/(auth)/auth-redirect/$platform')({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>) => ({
        code: search.code as string | undefined,
    }),
})
function RouteComponent() {
    const { platform } = Route.useParams()
    const { code } = Route.useSearch()
    const { useMutateRequest } = useRequest()
    const navigate = useNavigate()
    const hasMutated = useRef(false)
    const [isError, setIsError] = useState(false)
    const createUserConnection = useMutateRequest({
        url: "user_connections/",
        method: "post",
        successMessage: "User connection created successfully",
        errorMessage: "Failed to create user connection",
        onSuccess: (response) => {
            if ((response as unknown as { redirect_url: string })['redirect_url']) {
                window.location.href = (response as unknown as { redirect_url: string })['redirect_url']
            } else {
                setTimeout(() => {
                    navigate({ to: "/dashboard/account-settings/connections" })
                }, 1000)
            }
        },
        onError: () => {
            setIsError(true)
        },
    })
    useEffect(() => {
        if (hasMutated.current) return
        hasMutated.current = true
        createUserConnection.mutate({
            data: {
                connection: platform,
                code: code,
            },
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="flex flex-col items-center justify-center h-screen">
            {
                isError
                    ?
                    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6">
                        <div className="flex flex-col items-center gap-2">
                            <h2 className="text-lg font-bold text-gray-800">
                                Something went wrong
                            </h2>
                            <p className="text-gray-500 text-center max-w-md text-sm">
                                An unexpected error occurred. Please try again from the connections page,
                                or contact your account manager.
                            </p>
                        </div>
                        <Button
                            color="primary"
                            size="sm"
                            as={Link}
                            to='/dashboard/account-settings/connections'
                        >
                            Go back to Connections
                        </Button>
                    </div> : createUserConnection.isPending
                        ? <Spinner size="lg" className="m-auto" color="secondary" />
                        : createUserConnection.isSuccess
                            ? <div className="font-bold text-lg text-center">
                                User connection created successfully. Redirecting to connections page...
                                <Button
                                    color="primary"
                                    size="sm"
                                    as={Link}
                                    to="/dashboard/account-settings/connections"
                                >
                                    Go to connections page
                                </Button>
                            </div>
                            : <Button
                                color="primary"
                                size="sm"
                                as={Link}
                                to="/dashboard/account-settings/connections"
                            >
                                Go to connections page
                            </Button>
            }
        </div>
    )
}
